import TopNavBar from "@/components/public/TopNavBar"
import FullLoading from "@/components/public/animation/FullLoading"
import Loading from "@/components/public/animation/Loading"

export default (Vue) => {
  Vue.component('TopNavBar', TopNavBar)
  Vue.component('Loading', Loading)
}